'use client';
import React from 'react';
import { OrderNumber as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

function OrderNumberImpl(props: any) {
  const { order } = useOrderData();
  if (!order) return <SharedRender {...props} />;
  const orderNumber = order.display_id != null ? `#${order.display_id}` : order.id;
  return <SharedRender {...props} orderNumber={orderNumber} />;
}

export const OrderNumber: any = { ...Shared, render: (props: any) => <OrderNumberImpl {...props} /> };
export default OrderNumber;
